import { cacheableCallable } from "@/server/cacheableCallable";
import { cancelableCallable } from "@/server/cancelableCallable";
import { instance } from "../api-instance";

type GetWorkDataResponse = {
  data: {
    contactCompanyName?: string;
    jobTitle: string;
    workAddress?: string;
    sumAverageMonthEarning: number;
    sumAverageMonthEarningAdditional?: number;
    sumAdditionalIncome?: number;
    sumAdditionalIncomeDWH?: number;
    sumAdditionalIncomePti?: number;
    isRetiredOrSelfEmployed?: boolean;
    workPhone?: string;
    busyness: {
      id: string;
      name: string;
    };
    incomeSource?: {
      id: string;
      name: string;
    };
    expenses?: number;
    stagePeriod?: {
      id: string;
      name: string;
    };
  };
  result: boolean;
};

export const PassportApi = {
  getPassportData(): Promise<unknown> {
    return instance.get("passport/get").then((res) => res.data);
  },

  sendPassport(data: unknown): Promise<unknown> {
    return instance.post(`passport/save`, data).then((res) => res.data);
  },

  sendAddressData(addressData: unknown): Promise<unknown> {
    return instance.post(`address/save`, addressData).then((res) => res.data);
  },

  getWorkData(): Promise<GetWorkDataResponse> {
    return instance.get(`employment/get`).then((res) => res.data);
  },

  sendWorkData(
    workData: unknown
  ): Promise<{ result: true } | { result: false; errorMessage: string }> {
    return instance.post(`employment/save`, workData).then((res) => res.data);
  },

  findFms: cancelableCallable(
    (controller, data: unknown): Promise<unknown> =>
      instance
        .post(`passport/findFms`, data, { signal: controller.signal })
        .then((res) => res.data)
  ),

  getParty: cancelableCallable(
    (controller, data: unknown): Promise<unknown> =>
      instance
        .get(`employment/findParty?inputString={${data}}`, {
          signal: controller.signal,
        })
        .then((res) => res.data)
  ),

  getBusinessOptions(): Promise<unknown> {
    return instance.get(`employment/getDictionary`).then((res) => res.data);
  },

  checkIssueDate: cacheableCallable(
    (date: unknown): Promise<unknown> =>
      instance.post("passport/checkIssueDate", date).then((res) => res.data)
  ),
};
